import { ScrollTop } from "@/components/commons/ScrollTop";
import { AppDrawer } from "@/components/layout/elements/AppDrawer";
import { AppHeader } from "@/components/layout/elements/AppHeader";
import { LAST_AUTH_ROUTE_KEY } from "@/constants/common";
import { useMeAutoRefresh } from "@/features/auth/hooks/useMeAutoRefresh";
import { usePasskeyUserDetailsSync } from "@/features/auth/hooks/usePasskeyUserDetailsSync";
import { TopAlert } from "@/features/maintenance/components/TopAlert";
import { withAuth } from "@/hoc/withAuth";
import { useVisible } from "@/hooks/useVisible";
import { InitSetupProvider } from "@/providers/InitSetupProvider";
import { background } from "@/theme/colors";
import { spacing } from "@/theme/variables";
import { FCC } from "@/types/common";
import { setTimestampedRoute } from "@/utils/timestampedRoute";
import { Box, Stack, styled } from "@mui/material";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

export const CenterLayout: FCC = ({ children }) => {
  const showDrawer = useVisible();
  const { pathname, search } = useLocation();

  // Keep the current user fresh: poll /get-me every 2 min while active, pause on idle.
  useMeAutoRefresh();

  // Clear a stale email from this browser's passkey picker after メールアドレス変更.
  usePasskeyUserDetailsSync();

  // Remember the last authenticated page so the login "keep session" action can
  // return here when the login URL carries no redirectUrl/callback.
  useEffect(() => {
    setTimestampedRoute(LAST_AUTH_ROUTE_KEY, `${pathname}${search}`);
  }, [pathname, search]);

  return (
    <InitSetupProvider>
      <ScrollTop />
      <>
        <AppHeader isOpenDrawer={showDrawer.visible} toggleDrawer={showDrawer.toggle} />
        <StackWrapper direction="row">
          <AppDrawer isOpenDrawer={showDrawer.visible} toggleDrawer={showDrawer.toggle} />
          <ChildrenWrapper onClick={showDrawer.close}>
            <TopAlert />
            <Outlet />
            {children}
          </ChildrenWrapper>
        </StackWrapper>
      </>
    </InitSetupProvider>
  );
};

export const CenterLayoutWithAuth = withAuth(CenterLayout);

const ChildrenWrapper = styled(Box)`
  padding: ${spacing.md};
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  margin: 0 auto;
`;

const StackWrapper = styled(Stack)`
  min-height: calc(100vh - 57px);
  background-color: ${background.primary};
`;
